import { CardBackground, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { TScenarioProjections } from "@/types";

import ReductionBlock from "./ActionPlan/ReductionBlock";
import ScenarioProjectionsChart from "./ActionPlan/ScenarioProjectionsChart";

type ScenariosAndTrajectoryProps = {
  scenarioProjections: TScenarioProjections;
  averageYearlyTrajectoryReductionPercentage: number;
  reducedTrajectoryPercentage: number;
  reducedSbtiPercentage: number;
};

function ScenariosAndTrajectory({
  scenarioProjections,
  averageYearlyTrajectoryReductionPercentage,
  reducedTrajectoryPercentage,
  reducedSbtiPercentage,
}: ScenariosAndTrajectoryProps) {
  const { t } = useTranslation("trajectory");

  const lastProjectionYear = Object.keys(scenarioProjections.normal)
    .map((year) => Number(year))
    .sort()
    .at(-1);

  return (
    <CardBackground className="col-span-1">
      <Typography as="h2" step="2" weight="bold" className="mb-sm">
        {t("trajectory:trajectory.title")}
      </Typography>
      <ScenarioProjectionsChart scenarioProjections={scenarioProjections} />
      <div className="mt-xl gap-y-xs flex flex-col">
        <Typography step="1" weight="bold" as="h3">
          {t("trajectory:trajectory.reducingMyTrajectory")}
        </Typography>
        <div className="gap-x-xl p-sm border-grayscale-xx-light grid grid-cols-2 rounded-lg border">
          <ReductionBlock
            title={t("trajectory:trajectory.reductions.forLastProjectionYear", {
              year: lastProjectionYear,
            })}
            percentage={reducedTrajectoryPercentage / 100}
          />
          <ReductionBlock
            title={t("trajectory:trajectory.reductions.thisYear")}
            percentage={averageYearlyTrajectoryReductionPercentage / 100}
          />
        </div>
        <div className="p-sm border-grayscale-xx-light rounded-lg border">
          <ReductionBlock
            title={t("trajectory:trajectory.reductions.sbtiTarget", {
              year: lastProjectionYear,
            })}
            percentage={reducedSbtiPercentage / 100}
          />
        </div>
      </div>
    </CardBackground>
  );
}

export default ScenariosAndTrajectory;
